type RegisterPayload = {
  email: string;
  password: string;
  password_confirmation: string;
};

export const registerCandidateApi = async (payload: RegisterPayload) => {
  const res = await fetch(`https://admin-talentlink.digiline.id/api/register/candidate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }

  return res.json();
};

export const registerCompanyApi = async (payload: RegisterPayload) => {
  const res = await fetch(`https://admin-talentlink.digiline.id/api/register/company`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }

  return res.json();
};

// src/api/registerApi.ts

type ConfirmOtpPayload = {
  email: string;
  otp: string;
};

export const confirmOtpApi = async (payload: ConfirmOtpPayload) => {
  const res = await fetch(
    "https://admin-talentlink.digiline.id/api/register/confirm-otp",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }

  return res.json();
};

export const resendOtpApi = async (email: string) => {
  const res = await fetch(
    "https://admin-talentlink.digiline.id/api/register/resend-otp",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }

  return res.json();
};

